import "./index.scss";
import React from "react";

const AgreementPage = () => {
  return <div></div>;
};

export default AgreementPage;
